import { defineMessages } from "react-intl";

import { node as anesthesiology } from "src/modules/ltx/forms/phase-ii/consultations-ii/anesthesiology";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "form.consultations_ii",
		defaultMessage: "Konzíliumok II"
	}
});

export const node: ParentNode = {
	id: "consultationsIi",
	value: { type: "wizard", title: messages.title },
	children: [anesthesiology]
};
